import type { GroupData, MemberData } from "shared/schema";
import { Picker, type PickerProps, type QueryProps } from "shared/react";
import { GroupButton } from "../entity/EntityButton.js";
import { useQuery } from "../util/db.js";

export function GroupPicker({ query, onPick, isPicked, ...props }: PickerProps<string> & QueryProps<GroupData>): React.ReactElement {
	return (
		<Picker //
			store={useQuery("group", query)}
			mapper={({ id: gid }) => <GroupButton gid={gid} disabled mods="size-small flex-fit" />}
			more="Show more groups"
			empty="No groups"
			isPicked={isPicked ? ({ id: gid }) => isPicked(gid) : undefined}
			onPick={({ id }) => onPick(id)}
			{...props}
		/>
	);
}

/** Defaults to picking from the groups the user is an approved member of. */
export function MemberGroupPicker({ query, onPick, isPicked, ...props }: PickerProps<string> & QueryProps<MemberData>): React.ReactElement {
	return (
		<Picker //
			store={useQuery("member", query)}
			mapper={({ gid }) => <GroupButton gid={gid} disabled mods="size-small flex-fit" />}
			more="Show more groups"
			empty="No groups"
			isPicked={isPicked ? ({ gid }) => isPicked(gid) : undefined}
			onPick={({ gid }) => onPick(gid)}
			{...props}
		/>
	);
}
